import vTooltip from './Tooltip.vue';

export { vTooltip }



// WEBPACK FOOTER //
// ./src/baseComponents/components/Tooltip/index.js